module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tutorials-examples-business-process.json
// module id = 812
// module chunks = 14519979184847